import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import template from './full-product-catalog.html';
import{ MySiteRestService } from '@nuskin/my-site-api';
import { MySiteApp, OverwritePaperRadioButtonStyles } from '../../my-site-app';
import { nuskin } from '@nuskin/ns-util'

/**
 * @customElement
 * @polymer
 */
export class FullProductCatalog extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);
        this.descriptionOptions = {
            show: this.content.fullProductCatalogFormShowSearchInfo,
            hide: this.content.fullProductCatalogFormHideSearchInfo
        }
        this.description = this.descriptionOptions.show;

        // pass save method to form wrapper
        this.parentNode.saveForm = this.save();
    }

    static get properties() {
        return {
            fullProductCatalog: {
                type: Boolean,
                observer: '_handleFullProductCatalog'
            }
        }
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'full-product-catalog';
    }

    connectedCallback() {
        super.connectedCallback();

        this.overwritePaperRadioButtonStyles();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    ready() {
        super.ready();
        this.mySite = document.querySelector(MySiteApp.is);
        this.mySite.addEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
    }

    _subscribeToMySiteDataChanges() {
        if(this.mySite.currentForm !== FullProductCatalog.is) return;
        this.set('fullProductCatalog', !!this.mySite.mySiteData.storefront[this.mySite.subdomain][this.mySite.currentMarket].lang[this.mySite.currentLanguage].fullProductCatalog);
    }

    overwritePaperRadioButtonStyles() {
        OverwritePaperRadioButtonStyles(this.$.show);
        OverwritePaperRadioButtonStyles(this.$.hide);
    }

    _handleFullProductCatalog(newVal, oldVal) {
        this.setDescription();
        this.$.hide.checked = !newVal;
        this.$.show.checked = newVal;
        if(oldVal !== undefined) {
            this.parentElement.formTouched();
            this.parentElement.setFormValidity(true);
        }
    }

    _handleShowClick() {
        this.fullProductCatalog = true;
        this.$.hide.checked = false;
        this.$.show.checked = true;
        this.parentNode.updateAndNotify(this.fullProductCatalog, true, true, 'fullProductCatalog');
    }

    _handleHideClick() {
        this.fullProductCatalog = false;
        this.$.hide.checked = true;
        this.$.show.checked = false;
        this.parentNode.updateAndNotify(this.fullProductCatalog, true, true, 'fullProductCatalog');
    }

    setDescription() {
        this.description = this.fullProductCatalog
            ? this.descriptionOptions.show
            : this.descriptionOptions.hide;
    }

    save() {
        let that = this;
        return function() {

            // GA
            try {
                nuskin.events.publish(nuskin.events.mySite.SECTION_DATA_UPDATE, {
                    mySite: {
                        section: FullProductCatalog.is,
                        changed: {
                            fullProductCatalog: that.fullProductCatalog
                        }
                    }
                });
            } catch(err) {console.log(err)}

            return MySiteRestService.saveFullProductCatalog(that.fullProductCatalog, that.mySite.currentMarket, that.mySite.currentLanguage);
        }
    }

}

window.customElements.define(FullProductCatalog.is, FullProductCatalog);
